import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Case } from 'src/app/shared/models/case';
import moment from 'moment';
import { CasesFacade } from 'src/app/abstraction/cases.facade';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { OrdersStates } from 'src/app/core/enums/ordersStates';
import { Order } from 'src/app/shared/models/order';
import { Practice } from 'src/app/shared/models/practice';
import { Attention } from '../../../../shared/models/attention';
import { CasesIndicatorsValues } from 'src/app/shared/models/provisionalControlIndicators';
import { Provision } from '../../../../shared/models/provision';
import { GeneralService } from 'src/app/core/services/general.service';
import { ProvisionsFacade } from 'src/app/abstraction/provisions.facade';
import { AttentionStates } from 'src/app/core/enums/attentionsStates';
import { BreadcrumbService, CaseOperationsFlow } from 'src/app/shared/services/breadcrumb.service';
import { ViewManagementEntities } from 'src/app/core/enums/ViewManagementEntities';
import { THEME_COLOR_VARS } from 'src/app/core/theme/theme.constants';
import { AttentionType } from 'src/app/core/enums/attentionType';
import { ModulesFacade } from 'src/app/abstraction/modules.facade';
import { CaseModule } from 'src/app/shared/models/module';
import { AttentionsTimelineService } from 'src/app/abstraction/attentions-timeline.service';
import { ProvisionFee } from 'src/app/shared/models/provisionFee';
import { isUnfinishedCaseAttention } from 'src/app/shared/models/unfinished-case-attention';
@Component({
    selector: 'app-case-indicators',
    templateUrl: './case-indicators.component.html',
    styleUrls: ['./case-indicators.component.scss']
})
export class CaseIndicatorsComponent implements OnInit {

    @Input() attentions: Attention[];

    validityProvisionIndicator: boolean;
    nextDueDate = moment(new Date());
    caseDays: number;
    case: Case;
    _orders: Subscription;
    orders: Order[];
    practicesSupply = [];
    practices: Practice[];
    accumulatedFeesWithoutAttention: any[] = [];


    // COUNTERS
    counterProvisionsWithoutAttenttions: number = 0; colorProvisionsWithoutAttentions: string = THEME_COLOR_VARS.statusScheduled; isCounterProvisionsWithoutAttenttions: boolean;
    counterAttentionsWithoutBilling: number = 0; colorAttentionsWithoutBilling: string = THEME_COLOR_VARS.statusScheduled; isCounterAttentionsWithoutBilling: boolean;
    counterAttentionsOldAndOmitted: number = 0; colorAttentionsOldAndOmitted: string = THEME_COLOR_VARS.statusScheduled; isCounterAttentionsOldAndOmitted: boolean;
    counterSuppliesWithoutOrder: number = 0; colorSuppliesWithoutOrder: string = THEME_COLOR_VARS.statusScheduled; isCounterSuppliesWithoutOrder: boolean;
    counterBillingAttentions: number = 0; colorBillingAttentions: string = THEME_COLOR_VARS.statusScheduled; isCounterBillingAttentions: boolean;
    counterModulesWithoutBillingAttentions: number = 0; colorModulesWithoutBillingAttentions: string = THEME_COLOR_VARS.statusScheduled; isCounterModulesWithoutBillingAttentions: boolean;
    counterSuppliesNotDelivered: number = 0; colorSuppliesNotDelivered: string = THEME_COLOR_VARS.statusScheduled; isCounterSuppliesNotDelivered: boolean;
    counterSuppliesWithoutBilling: number = 0; colorSuppliesWithoutBilling: string = THEME_COLOR_VARS.statusScheduled; isCounterSuppliesWithoutBilling: boolean;
    counterSuppliesNotInformed: number = 0; colorSuppliesNotInformed: string = THEME_COLOR_VARS.statusScheduled; isCounterSuppliesNotInformed: boolean;
    suppliesWithoutOrderFlow: CaseOperationsFlow = 'SUPPLY';
    suppliesNotDeliveredFlow: CaseOperationsFlow = 'SUPPLY';
    suppliesWithoutBillingFlow: CaseOperationsFlow = 'SUPPLY';


    _case: Subscription;
    _allAttentions: Subscription;
    _filteredAttentions: Subscription;
    _provisions: Subscription;
    provisions: Provision[];
    allCaseProvisions: Provision[] = [];
    _dataSync: Subscription;

    historyModeActivated: boolean = false;
    _historyModeActivated: Subscription;
    _historyModeDate: Subscription;
    historyModeDate: Date;

    _caseIndicatorValues: Subscription;
    caseIndicatorValues: CasesIndicatorsValues;

    attentionsINRange: Attention[];
    historyFromDate: Date;
    historyToDate: Date;
    allAttentions: Attention[] = [];
    caseModules: CaseModule[] = [];

    btnsDisabled: boolean;
    anyPending$: Observable<boolean>;
    private _btnsDiasabled: Subscription;
    public ViewManagementEntities = ViewManagementEntities;
    practicesWithoutScheduleFlow: CaseOperationsFlow = 'PROVISION';
    attentionsOldAndOmittedFlow: CaseOperationsFlow = 'PROVISION';
    attentionsWithoutBillingFlow: CaseOperationsFlow = 'PROVISION';

    private isModuleLinkedProvisionFee(provisionFee: any): boolean {
        return provisionFee?.caseModuleId != null || provisionFee?.moduleId != null;
    }

    private getModuleProvisionFeeIds(): Set<number> {
        const moduleProvisionFeeIds = new Set<number>();
        (this.provisions ?? []).forEach(provision => {
            (provision?.provisionFees ?? []).forEach(provisionFee => {
                if (this.isModuleLinkedProvisionFee(provisionFee) && provisionFee?.id != null) {
                    moduleProvisionFeeIds.add(Number(provisionFee.id));
                }
            });
        });
        return moduleProvisionFeeIds;
    }

    private isModuleLinkedAttention(attention: Attention, moduleProvisionFeeIds?: Set<number>): boolean {
        if (!attention) {
            return false;
        }

        if (attention?.caseModuleId != null || (attention as any)?.moduleId != null) {
            return true;
        }

        const provisionFeeId = (attention as any)?.provisionFeeId;
        if (provisionFeeId == null) {
            return false;
        }

        const moduleFeeIds = moduleProvisionFeeIds ?? this.getModuleProvisionFeeIds();
        return moduleFeeIds.has(Number(provisionFeeId));
    }

    private getNonModuleAttentionsInRange(): Attention[] {
        const moduleProvisionFeeIds = this.getModuleProvisionFeeIds();
        return (this.attentionsINRange ?? []).filter(attention => !this.isModuleLinkedAttention(attention, moduleProvisionFeeIds));
    }

    private getNonModuleProvisionFees(provision: Provision) {
        return (provision?.provisionFees ?? []).filter(provisionFee => !this.isModuleLinkedProvisionFee(provisionFee));
    }

    private readonly includeModulesInIndicators = true;

    private getAttentionsForIndicators(): Attention[] {
        return this.includeModulesInIndicators
            ? (this.attentionsINRange ?? [])
            : this.getNonModuleAttentionsInRange();
    }

    private getProvisionFeesForIndicators(provision: Provision) {
        return this.includeModulesInIndicators
            ? (provision?.provisionFees ?? [])
            : this.getNonModuleProvisionFees(provision);
    }

    private getPreferredFlow<T>(items: T[], isModuleItem: (item: T) => boolean): CaseOperationsFlow {
        if (items.some(item => !isModuleItem(item))) {
            return 'PROVISION';
        }
        return items.some(isModuleItem) ? 'MODULE' : 'PROVISION';
    }

    private getPreferredSupplyFlow<T>(items: T[], isModuleItem: (item: T) => boolean): CaseOperationsFlow {
        if (items.some(item => !isModuleItem(item))) {
            return 'SUPPLY';
        }
        return items.some(isModuleItem) ? 'MODULE' : 'SUPPLY';
    }

    /* private normalizeCaseModuleId(attention: Attention): number | null {
        if (attention?.caseModuleId == null) {
            return null;
        }
        return Number(attention.caseModuleId);
    }

    private isSameCalendarDay(firstDate?: Date, secondDate?: Date): boolean {
        if (!firstDate || !secondDate) {
            return false;
        }

        const first = new Date(firstDate);
        const second = new Date(secondDate);

        return first.getFullYear() === second.getFullYear()
            && first.getMonth() === second.getMonth()
            && first.getDate() === second.getDate();
    } */

    /* private calculateModulesWithoutBillingAttentions(): void {
        const validStates = [AttentionStates.AGENDADA, AttentionStates.REALIZADA, AttentionStates.EN_CURSO];
        const moduleAttentions = (this.attentionsINRange ?? []).filter(att => att?.type === AttentionType.MODULE);

        this.counterModulesWithoutBillingAttentions = (moduleAttentions ?? []).filter(attention => {

            if (!validStates.includes(attention?.state?.id)) return false;

            const practiceCaseModuleId = this.normalizeCaseModuleId(attention);
            if (practiceCaseModuleId == null) return false;

            return !moduleAttentions.some(moduleAttention =>
                this.isSameCalendarDay(moduleAttention?.fromDate, attention?.fromDate)
                && this.normalizeCaseModuleId(moduleAttention) === practiceCaseModuleId
            );
        }).length;

        this.isCounterModulesWithoutBillingAttentions = true;
        this.colorModulesWithoutBillingAttentions = this.generalService.calculateColor(
            this.counterModulesWithoutBillingAttentions,
            (this.attentionsINRange ?? []).filter(a => a?.type === AttentionType.PRACTICE_MODULE).length
        );
    } */

    private calculateModulesWithoutBillingAttentions(): void {
        if (!this.attentionsINRange || !this.historyFromDate || !this.historyToDate) {
            this.resetCounterModulesWithoutBillingAttentions();
            return;
        }

        const rangeStart = moment(this.historyFromDate).startOf('day');
        const rangeEnd = moment(this.historyToDate).endOf('day');

        // Los case modules no se recortan por rango en el state, se filtran por solapamiento de vigencia.
        const modulesInSession = new Set<number>(
            (this.caseModules ?? [])
                .filter(caseModule => {
                    if (caseModule?.id == null) return false;
                    const moduleStart = caseModule?.fromDate ? moment(caseModule.fromDate) : rangeStart;
                    const moduleEnd = caseModule?.toDate ? moment(caseModule.toDate) : rangeEnd;
                    return moduleStart.isSameOrBefore(rangeEnd) && moduleEnd.isSameOrAfter(rangeStart);
                })
                .map(caseModule => Number(caseModule.id))
                .filter(Number.isFinite)
        );

        const modulesWithBillingAttention = new Set<number>(
            this.attentionsINRange
                .filter(attention => attention?.type === AttentionType.MODULE && attention?.caseModuleId != null)
                .map(attention => Number(attention.caseModuleId))
                .filter(Number.isFinite)
        );

        this.counterModulesWithoutBillingAttentions =
            Array.from(modulesInSession).filter(id => !modulesWithBillingAttention.has(id)).length;

        this.isCounterModulesWithoutBillingAttentions = true;
        this.colorModulesWithoutBillingAttentions = this.generalService.calculateColor(
            this.counterModulesWithoutBillingAttentions,
            modulesInSession.size || 1
        );
    }

    resetCounterModulesWithoutBillingAttentions() {
        this.isCounterModulesWithoutBillingAttentions = false;
        this.counterModulesWithoutBillingAttentions = 0;
        this.colorModulesWithoutBillingAttentions = null;
    }

    constructor(
        private casesFacade: CasesFacade,
        private generalService: GeneralService,
        private provisionsFacade: ProvisionsFacade,
        private breadcrumbService: BreadcrumbService,
        private modulesFacade: ModulesFacade,
        private attentionsTimeline: AttentionsTimelineService
    ) { }

    ngOnInit(): void {
        this.anyPending$ = this.attentionsTimeline.anyPending$;
        // this.provisionsService.markProvisions();

        this._historyModeDate = this.casesFacade.getCaseDateFilters$().subscribe(rangeDate => {
            if (!!rangeDate) {
                this.historyFromDate = rangeDate.historyFromDate;
                this.historyToDate = rangeDate.historyToDate;
            }
            this.refreshAttentionCounters();
        })

        // Get case
        this._case = this.casesFacade.getCase$().subscribe(res => {
            this.case = !!res ? res : null;
        });

        /* // ForkJoin made to await for both endpoints to respond
        const observable = forkJoin({ provisions: of(this.provisionsFacade.getProvisionsDisplayedOnScreen$()), orders: of(this.casesFacade.getOrdersDisplayedOnScreen$()) });
        observable.subscribe({
            next: values => {
                values.provisions.subscribe(provisions => {
                    if (!!provisions) {
                        this.provisions = provisions;
                        if (!!this.orders && this.orders.length > 0) {
                            this.composeProvisionFeeWithOrders();
                        }
                        this.calculateProvisionsWithoutAttentions();
                        this.calculateSuppliesWithoutOrder();
                    }
                })
                values.orders.subscribe(orders => {
                    if (!!orders) {
                        this.orders = orders;
                        if (!!this.provisions && this.provisions.length > 0) {
                            this.composeProvisionFeeWithOrders();
                            this.calculateSuppliesWithoutOrder();
                        }
                    }
                })
            }
        }) */
        this._dataSync = combineLatest([
        this.provisionsFacade.getProvisionsDisplayedOnScreen$(),
        this.casesFacade.getOrdersDisplayedOnScreen$(),
        this.modulesFacade.getCaseModules$(),
        this.provisionsFacade.getAllProvisionsCase$()
        ]).subscribe(([provisions, orders, caseModules, allCaseProvisions]) => {
            this.provisions = provisions ?? [];
            this.orders = orders ?? [];
            this.caseModules = caseModules ?? [];
            this.allCaseProvisions = allCaseProvisions ?? [];
            this.composeProvisionFeeWithOrders();
            this.refreshAttentionCounters();
        });
        this._btnsDiasabled = this.generalService.getDisabledBtnsPeriodSelector$().subscribe(btnsDiasabled => this.btnsDisabled = btnsDiasabled);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['attentions']) {
            this.attentionsINRange = changes['attentions'].currentValue?.filter(att => moment(att.fromDate).isBetween(this.historyFromDate, this.historyToDate, undefined, '[]'));
            this.allAttentions = changes['attentions'].currentValue ?? [];
            this.refreshAttentionCounters();
            // this.calculateSuppliesWithoutOrder();
        }
    }

//~~~~~ !!! IMPORTANT !!!~~~~~~~~//
///////// IF WE WANT TO MODIFY THESE FILTERS, WE ALSO NEED TO DO SO IN ATTENTIONS-LIST-CASE-COMPONENT TO GET THE SAME RESULTS./////////////////
//PRACTICES WITHOUT SCHEDULE PAINTED IN  PROVISIONS-DETAIL-COMPONENT

    // Calculate how many provisions without attentions

    calculateProvisionsWithoutAttentions() {
        if (!this.provisions || !this.attentionsINRange) {
            this.resetCounterProvisionsWithoutAttentions();
            return;
        }
        // Filtrar las provisiones excluyendo las que sean 'Entrega insumos' o `isSupply`
        const rangeStart = moment(this.historyFromDate).startOf('day');
        const rangeEnd = moment(this.historyToDate).endOf('day');
        const filteredProvisions = this.allCaseProvisions
            .filter(pr => pr.practice?.name !== 'Entrega insumos' && !pr.isSupply)
            .map(provision => ({
                ...provision,
                provisionFees: this.getProvisionFeesForIndicators(provision).filter(fee =>
                    (!fee.fromDate || moment(fee.fromDate).isSameOrBefore(rangeEnd)) &&
                    (!fee.toDate || moment(fee.toDate).isSameOrAfter(rangeStart))
                )
            }))
            .filter(provision => provision.provisionFees.length > 0);
        const attentionsById = new Set(this.getAttentionsForIndicators().map(att => att.provisionFeeId));
        const accumulatedFeesWithoutAttention: ProvisionFee[] = filteredProvisions
            .flatMap(provision => provision.provisionFees.filter(fee => !attentionsById.has(fee.id)));
        // Setear valores de contadores y colores
        this.isCounterProvisionsWithoutAttenttions = true;
        this.counterProvisionsWithoutAttenttions = accumulatedFeesWithoutAttention.length;
        this.practicesWithoutScheduleFlow = this.getPreferredFlow(
            accumulatedFeesWithoutAttention,
            provisionFee => this.isModuleLinkedProvisionFee(provisionFee)
        );
        this.colorProvisionsWithoutAttentions = this.generalService.calculateColor(this.counterProvisionsWithoutAttenttions, filteredProvisions.length);
        this.accumulatedFeesWithoutAttention = accumulatedFeesWithoutAttention;
    }

    // Método para resetear el estado de las provisiones sin atenciones
    resetCounterProvisionsWithoutAttentions() {
        this.isCounterProvisionsWithoutAttenttions = false;
        this.counterProvisionsWithoutAttenttions = 0;
        this.colorProvisionsWithoutAttentions = null;
        this.practicesWithoutScheduleFlow = 'PROVISION';
        this.accumulatedFeesWithoutAttention = [];
    }

    private refreshAttentionCounters(): void {
        const source = this.allAttentions ?? [];
        this.attentionsINRange = source.filter(att =>
            att?.fromDate &&
            moment(att.fromDate).isBetween(
                moment(this.historyFromDate).startOf('day'),
                moment(this.historyToDate).endOf('day'), undefined, '[]')
        );

        this.calculateProvisionsWithoutAttentions();
        this.calculateAttentionsOldAndOmitted();
        this.calculateAttentionsWithoutBilling();
        this.calculateBillingAttentions();
        this.calculateSuppliesNotDelivered();
        this.calculateSuppliesWithoutBilling();
        this.calculateSuppliesNotInformed();
        this.calculateSuppliesWithoutOrder();
        this.calculateModulesWithoutBillingAttentions();
    }

    // Calculate attentions without end
    calculateAttentionsOldAndOmitted() {
        this.isCounterAttentionsOldAndOmitted = false;
        this.counterAttentionsOldAndOmitted = 0;
        const filteredAttentions = this.getAttentionsForIndicators();
        const attentionsOldAndOmitted = filteredAttentions.filter(isUnfinishedCaseAttention);
        this.counterAttentionsOldAndOmitted = attentionsOldAndOmitted.length;
        this.attentionsOldAndOmittedFlow = this.getPreferredFlow(
            attentionsOldAndOmitted,
            attention => this.isModuleLinkedAttention(attention)
        );

        this.isCounterAttentionsOldAndOmitted = true;
        this.colorAttentionsOldAndOmitted = this.generalService.calculateColor(this.counterAttentionsOldAndOmitted, filteredAttentions?.length);

    }

    // Calculate attentions without billing
    calculateAttentionsWithoutBilling() {
        this.isCounterAttentionsWithoutBilling = false;
        this.counterAttentionsWithoutBilling = 0;
        const filteredAttentions = this.getAttentionsForIndicators();
        const attentionsWithoutBilling = filteredAttentions.filter(attention => {
            const isFiltered = !attention.notManageable && attention?.practice?.name != "Entrega insumos" &&
                [AttentionStates.REALIZADA, AttentionStates.NO_REALIZADA, AttentionStates.CREACION].includes(attention.state.id);
            return isFiltered;
        });
        this.counterAttentionsWithoutBilling = attentionsWithoutBilling.length;
        this.attentionsWithoutBillingFlow = this.getPreferredFlow(
            attentionsWithoutBilling,
            attention => this.isModuleLinkedAttention(attention)
        );
        this.isCounterAttentionsWithoutBilling = true;
        this.colorAttentionsWithoutBilling = this.generalService.calculateColor(this.counterAttentionsWithoutBilling, filteredAttentions.length);
        // const type = 'ATTENTIONS_WITHOUT_BILLING';
        // filteredAtt.forEach(att => {
        //     att.paintedType = type
        // })
    }

// Calculate billing attentions
calculateBillingAttentions() {
    this.isCounterBillingAttentions = false;
    this.counterBillingAttentions = 0;
    const filteredAttentions = this.getAttentionsForIndicators();
    if (!!filteredAttentions) {
        this.counterBillingAttentions = filteredAttentions ?
            filteredAttentions.filter(attention =>
                [AttentionStates.FACTURABLE].includes(attention.state.id)
                && !attention.notManageable && attention?.practice?.name != "Entrega insumos").length : 0
        this.isCounterBillingAttentions = true;
        this.colorBillingAttentions = this.generalService.calculateColor(this.counterBillingAttentions, filteredAttentions.length);
    }
}

//Calculate Supplies Without order
/* calculateSuppliesWithoutOrder() {
    this.isCounterSuppliesWithoutOrder = false;
    this.counterSuppliesWithoutOrder = 0;
    let supplies = this.provisions?.filter(prov => prov.isSupply && prov.practice?.name != 'Entrega insumos');
    let suppliesProvisionFees = supplies?.flatMap(supp => this.getNonModuleProvisionFees(supp));
    if (suppliesProvisionFees?.length > 0) {
        suppliesProvisionFees.forEach(pF => {
            if (pF?.orders?.length === 0) {
                this.counterSuppliesWithoutOrder++;
            } else if (pF?.orders) {
                const orderSupply = pF.orders.find(order => (order.state.id !== 3))
                !orderSupply ? this.counterSuppliesWithoutOrder++ : null;
            }
        });
    }
    this.colorSuppliesWithoutOrder = this.counterSuppliesWithoutOrder == 0 ? THEME_COLOR_VARS.statusScheduled : THEME_COLOR_VARS.statusNotDone
    this.isCounterSuppliesWithoutOrder = true;
} */
calculateSuppliesWithoutOrder() {
    this.isCounterSuppliesWithoutOrder = false;
    this.counterSuppliesWithoutOrder = 0;

    const supplies = this.provisions?.filter(prov => prov.isSupply && prov.practice?.name != 'Entrega insumos');
    const suppliesProvisionFees = supplies?.flatMap(supp => supp?.provisionFees ?? []);
    const suppliesWithoutOrder = suppliesProvisionFees?.filter(provisionFee => {
        if (provisionFee?.orders?.length === 0) {
            return true;
        }
        return !provisionFee?.orders?.some(order => order?.state?.id !== OrdersStates.CANCELADO);
    }) ?? [];

    this.counterSuppliesWithoutOrder = suppliesWithoutOrder.length;
    this.suppliesWithoutOrderFlow = this.getPreferredSupplyFlow(
        suppliesWithoutOrder,
        provisionFee => this.isModuleLinkedProvisionFee(provisionFee)
    );

    this.colorSuppliesWithoutOrder =
        this.counterSuppliesWithoutOrder == 0
            ? THEME_COLOR_VARS.statusScheduled
            : THEME_COLOR_VARS.statusNotDone;

    this.isCounterSuppliesWithoutOrder = true;
}

//Calculate Supplies not delivered
/* calculateSuppliesNotDelivered() {
    this.isCounterSuppliesNotDelivered = false;
    this.counterSuppliesNotDelivered = 0;
    const filteredAttentions = this.getNonModuleAttentionsInRange();
    if (!!filteredAttentions) {
        this.counterSuppliesNotDelivered = filteredAttentions ?
            filteredAttentions.filter(attention =>
                [AttentionStates.AGENDADA].includes(attention.state.id)
                && attention?.isSupply && attention?.practice?.name == "Entrega insumos").length : 0
        this.isCounterSuppliesNotDelivered = true;
        this.colorSuppliesNotDelivered = this.generalService.calculateColor(this.counterSuppliesNotDelivered, filteredAttentions.length);
    }
} */
calculateSuppliesNotDelivered() {
    this.isCounterSuppliesNotDelivered = false;
    this.counterSuppliesNotDelivered = 0;

    const orders = this.orders ?? [];
    const notCancelled = orders.filter(or => or?.state?.id !== OrdersStates.CANCELADO);
    const suppliesNotDelivered = notCancelled.filter(or => or?.state?.id !== OrdersStates.ENTREGADO);
    const moduleProvisionFeeIds = this.getModuleProvisionFeeIds();
    this.counterSuppliesNotDelivered = suppliesNotDelivered.length;
    this.suppliesNotDeliveredFlow = this.getPreferredSupplyFlow(
        suppliesNotDelivered,
        order => (order?.items ?? []).some(item => moduleProvisionFeeIds.has(Number(item?.provisionFeeId)))
    );

    this.isCounterSuppliesNotDelivered = true;
    this.colorSuppliesNotDelivered = this.generalService.calculateColor(
        this.counterSuppliesNotDelivered,
        notCancelled.length > 0 ? notCancelled.length : 1
    );
}

//Calculate Supplies without billing
calculateSuppliesWithoutBilling() {
    this.isCounterSuppliesWithoutBilling = false;
    this.counterSuppliesWithoutBilling = 0;
    const filteredAttentions = this.attentionsINRange ?? [];
    const suppliesWithoutBilling = filteredAttentions.filter(attention =>
        [AttentionStates.REALIZADA].includes(attention.state.id)
        && attention?.isSupply && attention?.practice?.name != "Entrega insumos"
    );
    if (!!filteredAttentions) {
        this.counterSuppliesWithoutBilling = suppliesWithoutBilling.length;
        this.suppliesWithoutBillingFlow = this.getPreferredSupplyFlow(
            suppliesWithoutBilling,
            attention => this.isModuleLinkedAttention(attention)
        );
        this.isCounterSuppliesWithoutBilling = true;
        this.colorSuppliesWithoutBilling = this.generalService.calculateColor(this.counterSuppliesWithoutBilling, filteredAttentions.length);
    }
}

//Calculate Supplies not informed
calculateSuppliesNotInformed() {
    this.isCounterSuppliesNotInformed = false;
    this.counterSuppliesNotInformed = 0;
    const filteredAttentions = this.attentionsINRange ?? [];
    if (!!filteredAttentions) {
        this.counterSuppliesNotInformed = filteredAttentions ?
            filteredAttentions.filter(attention =>
                attention?.isSupply && attention?.practice?.name != "Entrega insumos" &&
                [AttentionStates.NO_INFORMADA, AttentionStates.FACTURABLE].includes(attention.state.id)
            ).length : 0
        this.isCounterSuppliesNotInformed = true;
        this.colorSuppliesNotInformed = this.generalService.calculateColor(this.counterSuppliesNotInformed, filteredAttentions.length);
    }
}


composeProvisionFeeWithOrders() {
    this.provisions = this.provisions?.map(prov => {
        prov.provisionFees = prov.provisionFees.map(pF => {
            let aux = [];
            if (this.orders != null && this.orders?.length > 0) {
                this.orders.forEach(or => {
                    let itemForProvFee = or?.items?.find(i => pF.id == i.provisionFeeId);
                    if (itemForProvFee != null) {
                        aux.push(or)
                    }
                })
            }
            pF.orders = aux;
            return pF
        })
        return prov
    })
}

goToScreen(event: ViewManagementEntities, flow?: CaseOperationsFlow) {
    this.breadcrumbService.setScreenToJump(event, flow)
}

ngOnDestroy(): void {
        !!this._case ? this._case.unsubscribe() : null;
!!this._historyModeDate ? this._historyModeDate.unsubscribe() : null;
!!this._btnsDiasabled ? this._btnsDiasabled.unsubscribe() : null;
!!this._dataSync ? this._dataSync.unsubscribe() : null;
    }
}
